module.exports = __webpack_public_path__ + "officialStatic/img/school1.ab0b8fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/school1.png
// module id = 36K/
// module chunks = 0